import BlockOneImg from "../assets/images/modal/school_design_1.png"
import UnionBlockOneImg from "../assets/images/modal/union_design_1.png"
import BlockTwoImg from "../assets/images/modal/school_design_2.png"
import UnionBlockTwoImg from "../assets/images/modal/union_design_2.png"
import BlockThreeImg from "../assets/images/modal/school_design_3.png"
import UnionBlockThreeImg from "../assets/images/modal/union_design_3.png"
import BlockFourImg from "../assets/images/modal/school_design_4.png"
import UnionBlockFourImg from "../assets/images/modal/union_design_4.png"
import BlockFiveImg from "../assets/images/modal/school_design_pants.png"
import BlockSixImg from "../assets/images/modal/school_design_hat.png"
import BlockSevenImg from "../assets/images/modal/school_design_bag.png"
import BlockEightImg from "../assets/images/modal/school_design_crossbag.png"
import Standard from "../assets/images/image-073.jpeg"
import Classic from "../assets/images/image-068.jpeg"
import Universal from "../assets/images/image-074.jpeg"
import Zip from "../assets/images/image-079.jpeg"
import TShirt from "../assets/images/image-081.jpeg"
import Crewneck from "../assets/images/image-087.jpeg"
import Cosy from "../assets/images/image-088.jpeg"
import CrossBody from "../assets/images/image-093.jpeg"
import Bag from "../assets/images/image-094.jpeg"
import Hat from "../assets/images/image-100.jpeg"
import ClassicFont from "../assets/images/classic_font.png"
import ModernFont from "../assets/images/modern_font.png"
import CollegeFont from "../assets/images/college_font.png"

type ClothType = {
  [key: string]: {
    img: string
    designTypes: {
      [key: string]: {
        title: string
        img: string
      }
    }
    colors: {
      [color: string]: string
    }
    sizes: string[]
  }
}

export const schoolCloth: ClothType = {
  // hoodStandard: {
  //   img: Standard,
  //   designTypes: {
  //     design1: {
  //       title: 'design1',
  //       img: BlockOneImg,
  //     },
  //     design2: {
  //       title: 'design2',
  //       img: BlockTwoImg,
  //     },
  //     design3: {
  //       title: 'design3',
  //       img: BlockThreeImg,
  //     },
  //     design4: {
  //       title: 'design4',
  //       img: BlockFourImg,
  //     },
  //   },
  //   colors: {
  //     navy: 'rgb(0, 23, 64)',
  //     black: '#000',
  //     darkChocolate: 'rgb(72, 57, 44)',
  //     lightBlue: 'rgb(189, 206, 226)',
  //     mintGreen: 'rgb(197, 229, 189)',
  //     orchid: 'rgb(180, 168, 205)',
  //     safetyPink: 'rgb(241, 120, 156)',
  //     sapphire: 'rgb(11, 105, 176)',
  //     lightHeather: 'rgb(213, 214, 216)',
  //   },
  //   sizes:["S", "M", "L", "XL", "XXL"]
  // },
  // hoodUniversal: {
  //   img: Universal,
  //   designTypes: {
  //     design1: {
  //       title: 'design1',
  //       img: BlockOneImg,
  //     },
  //     design2: {
  //       title: 'design2',
  //       img: BlockTwoImg,
  //     },
  //     design3: {
  //       title: 'design3',
  //       img: BlockThreeImg,
  //     },
  //     design4: {
  //       title: 'design4',
  //       img: BlockFourImg,
  //     },
  //   },
  //   colors: {
  //     navy: 'rgb(0, 23, 64)',
  //     black: '#000',
  //     gold: 'rgb(245, 156, 81)',
  //     bordeaux: 'rgb(123, 39, 44)',
  //     white: '#fff',
  //     lightHeather: 'rgb(213, 214, 216)',
  //   },
  //   sizes:["XS", "S", "M", "L", "XL", "XXL"]
  // },
  hoodClassic: {
    img: Classic,
    designTypes: {
      design1: {
        title: 'design1',
        img: BlockOneImg,
      },
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      bottleGreen: 'rgb(32, 96, 66)',
      white: '#fff',
      lightHeather: 'rgb(213, 214, 216)',
      bordeaux: 'rgb(123, 39, 44)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  zipHood: {
    img: Zip,
    designTypes: {
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  crewneck: {
    img: Crewneck,
    designTypes: {
      design1: {
        title: 'design1',
        img: BlockOneImg,
      },
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  tShirtUnisex: {
    img: TShirt,
    designTypes: {
      design1: {
        title: 'design1',
        img: BlockOneImg,
      },
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
      white: '#fff',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  cosyJoggers: {
    img: Cosy,
    designTypes: {
      design1: {
        title: 'Design Cosy Joggers',
        img: BlockFiveImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["XS", "S", "M", "L", "XL", "XXL"]
  },
  toteBag: {
    img: Bag,
    designTypes: {
      design1: {
        title: 'Design Tote bag',
        img: BlockSevenImg,
      },
    },
    colors: {
      natureWhite: '#0003B5',
    },
    sizes:[]
  },
  // crossbodyBag: {
  //   img: CrossBody,
  //   designTypes: {
  //     design1: {
  //       title: 'Design Crossbody bag',
  //       img: BlockEightImg,
  //     },
  //   },
  //   colors: {
  //     black: '#000',
  //   },
  //   sizes:[]
  // },
  // bucketHat: {
  //   img: Hat,
  //   designTypes: {
  //     design1: {
  //       title: 'Design Bucket hat',
  //       img: BlockSixImg,
  //     },
  //   },
  //   colors: {
  //     black: '#000',
  //   },
  //   sizes:[]
  // },
}

export const unionCloth: ClothType = {
  // hoodStandard: {
  //   img: Standard,
  //   designTypes: {
  //     design1: {
  //       title: 'design1',
  //       img: UnionBlockOneImg,
  //     },
  //     design2: {
  //       title: 'design2',
  //       img: UnionBlockTwoImg,
  //     },
  //     design3: {
  //       title: 'design3',
  //       img: UnionBlockThreeImg,
  //     },
  //     design4: {
  //       title: 'design4',
  //       img: UnionBlockFourImg,
  //     },
  //   },
  //   colors: {
  //     navy: 'rgb(0, 23, 64)',
  //     black: '#000',
  //     darkChocolate: 'rgb(72, 57, 44)',
  //     lightBlue: 'rgb(189, 206, 226)',
  //     mintGreen: 'rgb(197, 229, 189)',
  //     orchid: 'rgb(180, 168, 205)',
  //     safetyPink: 'rgb(241, 120, 156)',
  //     sapphire: 'rgb(11, 105, 176)',
  //     lightHeather: 'rgb(213, 214, 216)',
  //   },
  //   sizes:["S", "M", "L", "XL", "XXL"]
  // },
  // hoodUniversal: {
  //   img: Universal,
  //   designTypes: {
  //     design1: {
  //       title: 'design1',
  //       img: UnionBlockOneImg,
  //     },
  //     design2: {
  //       title: 'design2',
  //       img: UnionBlockTwoImg,
  //     },
  //     design3: {
  //       title: 'design3',
  //       img: UnionBlockThreeImg,
  //     },
  //     design4: {
  //       title: 'design4',
  //       img: UnionBlockFourImg,
  //     },
  //   },
  //   colors: {
  //     navy: 'rgb(0, 23, 64)',
  //     black: '#000',
  //     gold: 'rgb(245, 156, 81)',
  //     bordeaux: 'rgb(123, 39, 44)',
  //     white: '#fff',
  //     lightHeather: 'rgb(213, 214, 216)',
  //   },
  //   sizes:["XS", "S", "M", "L", "XL", "XXL"]
  // },
  hoodClassic: {
    img: Classic,
    designTypes: {
      design1: {
        title: 'design1',
        img: UnionBlockOneImg,
      },
      design2: {
        title: 'design2',
        img: UnionBlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: UnionBlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: UnionBlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      bottleGreen: 'rgb(32, 96, 66)',
      white: '#fff',
      lightHeather: 'rgb(213, 214, 216)',
      bordeaux: 'rgb(123, 39, 44)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  zipHood: {
    img: Zip,
    designTypes: {
      design2: {
        title: 'design2',
        img: UnionBlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: UnionBlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: UnionBlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  crewneck: {
    img: Crewneck,
    designTypes: {
      design1: {
        title: 'design1',
        img: UnionBlockOneImg,
      },
      design2: {
        title: 'design2',
        img: UnionBlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: UnionBlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: UnionBlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  tShirtUnisex: {
    img: TShirt,
    designTypes: {
      design1: {
        title: 'design1',
        img: UnionBlockOneImg,
      },
      design2: {
        title: 'design2',
        img: UnionBlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: UnionBlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: UnionBlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
      white: '#fff',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
}

export const eventCloth: ClothType = {
  // hoodStandard: {
  //   img: Standard,
  //   designTypes: {
  //     design1: {
  //       title: 'design1',
  //       img: BlockOneImg,
  //     },
  //     design2: {
  //       title: 'design2',
  //       img: BlockTwoImg,
  //     },
  //     design3: {
  //       title: 'design3',
  //       img: BlockThreeImg,
  //     },
  //     design4: {
  //       title: 'design4',
  //       img: BlockFourImg,
  //     },
  //   },
  //   colors: {
  //     navy: 'rgb(0, 23, 64)',
  //     black: '#000',
  //     darkChocolate: 'rgb(72, 57, 44)',
  //     lightBlue: 'rgb(189, 206, 226)',
  //     mintGreen: 'rgb(197, 229, 189)',
  //     orchid: 'rgb(180, 168, 205)',
  //     safetyPink: 'rgb(241, 120, 156)',
  //     sapphire: 'rgb(11, 105, 176)',
  //     lightHeather: 'rgb(213, 214, 216)',
  //   },
  //   sizes:["S", "M", "L", "XL", "XXL"]
  // },
  // hoodUniversal: {
  //   img: Universal,
  //   designTypes: {
  //     design1: {
  //       title: 'design1',
  //       img: BlockOneImg,
  //     },
  //     design2: {
  //       title: 'design2',
  //       img: BlockTwoImg,
  //     },
  //     design3: {
  //       title: 'design3',
  //       img: BlockThreeImg,
  //     },
  //     design4: {
  //       title: 'design4',
  //       img: BlockFourImg,
  //     },
  //   },
  //   colors: {
  //     navy: 'rgb(0, 23, 64)',
  //     black: '#000',
  //     gold: 'rgb(245, 156, 81)',
  //     bordeaux: 'rgb(123, 39, 44)',
  //     white: '#fff',
  //     lightHeather: 'rgb(213, 214, 216)',
  //   },
  //   sizes:["XS", "S", "M", "L", "XL", "XXL"]
  // },
  hoodClassic: {
    img: Classic,
    designTypes: {
      design1: {
        title: 'design1',
        img: BlockOneImg,
      },
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      bottleGreen: 'rgb(32, 96, 66)',
      white: '#fff',
      lightHeather: 'rgb(213, 214, 216)',
      bordeaux: 'rgb(123, 39, 44)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  zipHood: {
    img: Zip,
    designTypes: {
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  crewneck: {
    img: Crewneck,
    designTypes: {
      design1: {
        title: 'design1',
        img: BlockOneImg,
      },
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  tShirtUnisex: {
    img: TShirt,
    designTypes: {
      design1: {
        title: 'design1',
        img: BlockOneImg,
      },
      design2: {
        title: 'design2',
        img: BlockTwoImg,
      },
      design3: {
        title: 'design3',
        img: BlockThreeImg,
      },
      design4: {
        title: 'design4',
        img: BlockFourImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
      white: '#fff',
    },
    sizes:["S", "M", "L", "XL", "XXL"]
  },
  cosyJoggers: {
    img: Cosy,
    designTypes: {
      design1: {
        title: 'Design Cosy Joggers',
        img: BlockFiveImg,
      },
    },
    colors: {
      navy: 'rgb(0, 23, 64)',
      black: '#000',
      lightHeather: 'rgb(213, 214, 216)',
    },
    sizes:["XS", "S", "M", "L", "XL", "XXL"]
  },
  toteBag: {
    img: Bag,
    designTypes: {
      design1: {
        title: 'Design Tote bag',
        img: BlockSevenImg,
      },
    },
    colors: {
      natureWhite: '#0003B5',
    },
    sizes:[]
  },
  // crossbodyBag: {
  //   img: CrossBody,
  //   designTypes: {
  //     design1: {
  //       title: 'Design Crossbody bag',
  //       img: BlockEightImg,
  //     },
  //   },
  //   colors: {
  //     black: '#000',
  //   },
  //   sizes:[]
  // },
  // bucketHat: {
  //   img: Hat,
  //   designTypes: {
  //     design1: {
  //       title: 'Design Bucket hat',
  //       img: BlockSixImg,
  //     },
  //   },
  //   colors: {
  //     black: '#000',
  //   },
  //   sizes:[]
  // },
}

type PrintColorsType = {
  [key: string]: string
}

export const printColors: PrintColorsType = {
  white: 'rgb(255, 255, 255)',
  black: 'rgb(0, 0, 0)',
  navy: 'rgb(0, 40, 85)',
  blue: 'rgb(0, 114, 206)',
  green: 'rgb(32, 92, 64)',
  red: 'rgb(228, 0, 43)',
  yellow: 'rgb(255, 233, 0)',
  orange: 'rgb(255, 143, 28)',
  darkRed: 'rgb(124, 37, 41)',
  gold: 'rgb(211, 188,141)',
  roseGold: 'rgb(242,  212, 215)',
  champagne: 'rgb(223, 209, 167)',
  multiColor: `linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%)`
}

export const logoFonts: {
  [key: string]: {
    title: string
    img: string
  }
} = {
  classic: {
    title: 'classic',
    img: ClassicFont,
  },
  modern: {
    title: 'modern',
    img: ModernFont,
  },
  college: {
    title: 'college',
    img: CollegeFont,
  }
}
